import datapoints from '../datapoints';
import { makePostRequest } from 'owa-ows-gateway';
import { getGuid } from 'owa-guid';
import { PerformanceDatapoint } from 'owa-analytics';
import { getDefaultOptions, OwsOptionsFeatureType, lazyCreateOrUpdateOptionsForFeature, } from 'owa-outlook-service-options';
var endpoint = 'ows/api/beta/Addins/PinAddins';
var perfDatapoint = datapoints.PinRequest.datapoint;
/**
 * This should only be called during the opt-in FRE and happen before OWA is visible to the user
 */
export default function makePinRequest() {
    var correlationId = getGuid();
    var datapoint = new PerformanceDatapoint(perfDatapoint.name);
    makePostRequest(endpoint, { correlationId: correlationId, defaults: getDefaultOptions()[OwsOptionsFeatureType.SurfaceActions] }, correlationId, true /* returnFullResponse */)
        .then(function (response) {
        datapoint.addCustomData(perfDatapoint.customData(correlationId, response.status));
        if (response.status == 200) {
            response.text().then(function (body) {
                lazyCreateOrUpdateOptionsForFeature.importAndExecute(OwsOptionsFeatureType.SurfaceActions, JSON.parse(body));
            });
        }
        datapoint.end();
    })
        .catch(function () {
        // Make*Request has no thowing path, but just in case
        datapoint.end();
    });
}
//# sourceMappingURL=makePinRequest.js.map